{
  "#SUBKUNDEN": {
    "TITLE": "Subkunden",
    "PAGES": {
      "SUBKUNDEN": {
        "HEADER": "Subkunden verwalten",
        "SUBKUNDEN": "Subkunden",
        "INACTIVE": "Inaktiv",
        "ACTIVE": "Aktive: ",
        "ACTIVE_ONLY": "Nur Aktive anzeigen",
        "CREATED": "erstellt am ",
        "FILTER": "Filtern"
      }
    },
    "DIALOGS": {
      "CREATE": {
        "HEADER": "Subkunde anlegen",
        "NUMBER": "Nummer",
        "NAME": "Bezeichnung",
        "ACTIVE": "Aktiv",
        "SUBMIT": "Speichern"
      },
      "EDIT": {
        "HEADER": "Subkunden bearbeiten",
        "NAME": "Bezeichnung",
        "ACTIVE": "Aktiv",
        "SUBMIT": "Speichern"
      }
    },
    "MENU": {
      "LIST": "Liste",
      "CREATE": "Erstellen",
      "EDIT": "Bearbeiten"
    },
    "MESSAGES": {
      "SAVE_SUCCESS": "Der Subkunde wurde gespeichert"
    }
  }
}
